import  {booking_engines}  from "./bookingEngines"

import dayjs from 'dayjs'
import 'dayjs/locale/ja'
import customParseFormat from "dayjs/plugin/customParseFormat"


export default{

    setDayjs(){
        dayjs.extend(customParseFormat)
    },

    buildUrlBooking(  url ){
        const urlBase = new URL(url)
        let queryParams = new URLSearchParams(urlBase.search)
        queryParams.delete('_ga')
        queryParams.delete('_gl')
        return{
            origin: urlBase.origin + urlBase.pathname,
            query:  queryParams.toString() != '' ? `?${queryParams.toString()}` : '',
            hash: urlBase.hash,
            href: urlBase.href
        }
    },

    buildParamsBooking({ engine , bookingData }){
        
        let objectQueryParams = { }
        let data = ''

        if( typeof booking_engines[engine]['cbBuildParams'] == 'function' ){
            objectQueryParams = booking_engines[engine]['cbBuildParams'](bookingData);
        }else{


            Object.keys(booking_engines[engine]).map( ( keyParam ) => {
                if( keyParam !== 'date-engine-format' && bookingData[keyParam] !== "" && bookingData[keyParam] !== undefined ){
    
                    if(keyParam === 'checkin' || keyParam === 'checkout'){
                        data = this.parseDate({
                            date:  bookingData[keyParam],
                            format: booking_engines[engine]['date-engine-format']
                        })
                    }else{
                        data = bookingData[keyParam]
                    }
    
                    objectQueryParams = {
                        ...objectQueryParams,
                        [booking_engines[engine][keyParam]] : data
                    }
                }
            })
        }
        
        /**
             * Extracts the value of the input with name 'cm_mmc'
             * from the DOM and adds it to the objectQueryParams object.
        **/
        if(engine==='IHG'){
            const cm_mmc = document.querySelector('.booking-cms__form form input[name="cm_mmc"]');
            if(cm_mmc && cm_mmc.value !== ''){
                objectQueryParams['cm_mmc'] = cm_mmc.value;
            }
        }
        
        const params = new URLSearchParams(objectQueryParams)
        
        return decodeURIComponent(params.toString())

    },

    parseDate({ date , format , parseFormat = 'D/M/YYYY' }){

        this.setDayjs()

        const dateWithFormat = dayjs(date , parseFormat).format(format)

        return dateWithFormat === 'Invalid Date' ?  dayjs().format(format) : dateWithFormat

    },

    decorateUrlGA(urlString) {
        var ga = window[window['GoogleAnalyticsObject']];
        var tracker;
        if (ga && typeof ga.getAll === 'function') {
            tracker = ga.getAll()[0];
            // Uses the first tracker created on the page
            urlString = (new window.gaplugins.Linker(tracker)).decorate(urlString);
        }
        return urlString;
    },

    decorateUrlGA4(urlString){
        var generateLinkerParam = function(a) {
            // Function to properly grab ID's from Cookies
            var getCookiebyName = function(name) {
                var pair = document.cookie.match(new RegExp(name + '=([^;]+)'));
                return !!pair ? pair[1].match(/GA1\.[0-9]\.(.+)/)[1] : undefined;
            };
        
            // These are the 3 values used by the new linker
            var cookies = {
                _ga: getCookiebyName("_ga"),
                // Google Analytics GA ID
                _gac: undefined,
                // Google Remarketing
                _gid: getCookiebyName("_gid")// Google ID
            };
        
            // Calculate current browser_fingerprint based on UA, time, timezone and language
            // 
            var browser_fingerprint = (function(a, b) {
                var F = function(a) {
                    // Didnt check what this does, the algo just needs F to be defined. commenting out
                    Ne.set(a)
                };
                a = [window.navigator.userAgent, (new Date).getTimezoneOffset(), window.navigator.userLanguage || window.navigator.language, Math.floor((new Date).getTime() / 60 / 1E3) - (void 0 === b ? 0 : b), a].join("*");
                if (!(b = F)) {
                    b = Array(256);
                    for (var c = 0; 256 > c; c++) {
                        for (var d = c, e = 0; 8 > e; e++)
                            d = d & 1 ? d >>> 1 ^ 3988292384 : d >>> 1;
                        b[c] = d
                    }
                }
        
                F = b;
                b = 4294967295;
                for (c = 0; c < a.length; c++)
                    b = b >>> 8 ^ F[(b ^ a.charCodeAt(c)) & 255];
                return ((b ^ -1) >>> 0).toString(36);
            }
            )();
        
            // Function to hash the cookie value
            // The following functions takes a string and returns a hash value.
            var hash_cookie_value = function(val) {
                var A, C, D = function(a) {
                    A = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.";
                    C = {
                        "0": 52,
                        "1": 53,
                        "2": 54,
                        "3": 55,
                        "4": 56,
                        "5": 57,
                        "6": 58,
                        "7": 59,
                        "8": 60,
                        "9": 61,
                        "A": 0,
                        "B": 1,
                        "C": 2,
                        "D": 3,
                        "E": 4,
                        "F": 5,
                        "G": 6,
                        "H": 7,
                        "I": 8,
                        "J": 9,
                        "K": 10,
                        "L": 11,
                        "M": 12,
                        "N": 13,
                        "O": 14,
                        "P": 15,
                        "Q": 16,
                        "R": 17,
                        "S": 18,
                        "T": 19,
                        "U": 20,
                        "V": 21,
                        "W": 22,
                        "X": 23,
                        "Y": 24,
                        "Z": 25,
                        "a": 26,
                        "b": 27,
                        "c": 28,
                        "d": 29,
                        "e": 30,
                        "f": 31,
                        "g": 32,
                        "h": 33,
                        "i": 34,
                        "j": 35,
                        "k": 36,
                        "l": 37,
                        "m": 38,
                        "n": 39,
                        "o": 40,
                        "p": 41,
                        "q": 42,
                        "r": 43,
                        "s": 44,
                        "t": 45,
                        "u": 46,
                        "v": 47,
                        "w": 48,
                        "x": 49,
                        "y": 50,
                        "z": 51,
                        "-": 62,
                        "_": 63,
                        ".": 64
                    };
                    for (var b = [], c = 0; c < a.length; c += 3) {
                        var d = c + 1 < a.length
                          , e = c + 2 < a.length
                          , g = a.charCodeAt(c)
                          , f = d ? a.charCodeAt(c + 1) : 0
                          , h = e ? a.charCodeAt(c + 2) : 0
                          , p = g >> 2;
                        g = (g & 3) << 4 | f >> 4;
                        f = (f & 15) << 2 | h >> 6;
                        h &= 63;
                        e || (h = 64,
                        d || (f = 64));
                        b.push(A[p], A[g], A[f], A[h])
                    }
                    return b.join("")
                };
                return D(String(val));
            };
        
            // Now we have all the data Let's build the linker String! =)
            // First value is a fixed "1" value, the current GA code does the same. May change in a future
            return ["1", browser_fingerprint, "_ga", hash_cookie_value(cookies._ga), "_gid", hash_cookie_value(cookies._gid)].join('*');
        };

        var linkerParam = generateLinkerParam();

        var url = new URL(urlString);

        url.searchParams.append('_gl' , linkerParam);

        return url.toString();
    },

    decorateUrlGA4New(url) {
        const urlObj = new URL(url);
        const baseURL = urlObj.origin + urlObj.pathname; // Extract the base URL
        const params = new URLSearchParams(urlObj.search); // Extract query parameters

        // Create the form element
        const form = document.createElement("form");
        form.method = "GET"; // or "POST" depending on your requirement
        form.target = "_blank"; // or "POST" depending on your requirement
        form.action = baseURL;

        // Loop through each query parameter and create hidden input fields
        params.forEach((value, key) => {
            const input = document.createElement("input");
            input.type = "hidden";
            input.name = key;
            input.value = value;
            form.appendChild(input);
        });

        // Append the form to the body (or any other desired container)
        document.body.appendChild(form);
        form.submit();
        form.remove();
    },

    getRangeDates( minDate ){
        const minDateJs = dayjs(minDate)
        const now = dayjs()
        const difference = minDateJs.diff(now , 'day')
        let disabledDates = []

        if( difference > 0 ){
            for( let day = 0; day <= difference; day++ ){
                disabledDates.push( now.add(day , 'day').format('D-M-YYYY')  )
            }
        }

        return disabledDates


    },

    getInitialRangeDates( minDays = 1 , minDate ){
        let  minDateDefault = null
        const now = dayjs()
        const minDateCMS = dayjs(minDate).add(0 , 'day')
        if( now.isAfter(minDateCMS) ){
            minDateDefault = now
        }else{
            minDateDefault = minDateCMS
        }
        const startDate = dayjs(minDateDefault).add(0 , 'day')
        const endDate =  minDateDefault.add(minDays , 'day')
        return { start: startDate.format('D-M-YYYY') , end: endDate.format('D-M-YYYY') }
    },

}
